/**
 * Created by spepa on 21.11.2022
 */

const DonorProgressTab = cleverapps.Layout.extend({
    ctor: function (config, reward, onUpdateTab, onClose) {
        this.onUpdateTab = onUpdateTab;
        this.onClose = onClose;

        this.config = config;
        this.reward = reward;

        let items;

        if (this.config.donors.length === 1) {
            items = [
                this.createTimer(),
                this.createDesc(),
                this.createPreview(),
                this.createFindButton()
            ];
        } else {
            items = [
                this.createDesc(),
                this.createPreview(),
                this.createDonors(),
                this.createTimer()
            ];
        }

        this._super(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.DonorProgressTab.margin
        });
    },

    onSelectTab: function () {
        const percent = cleverapps.achievements.calcProgress(this.config);
        const prevPercent = cleverapps.achievements.calcProgress(this.config, true);

        cleverapps.achievements.clearPendingProgress(this.config);

        if (percent === prevPercent) {
            this.bar.setPercentage(percent);
        } else {
            this.bar.setPercentage(prevPercent);

            const progressTime = 0.8;

            if (this.help) {
                this.help.disable();
            }

            this.unit.runAction(new cc.Sequence(
                new cc.DelayTime(0.5),
                cleverapps.effects.fireAction("donor.progress"),
                new cc.CallFunc(() => {
                    this.bar.setPercentage(percent, {
                        time: progressTime,
                        animated: true
                    });
                }),
                new cc.DelayTime(progressTime),
                new cc.CallFunc(() => {
                    if (this.reward) {
                        if (this.unit.hasAnimation && this.unit.hasAnimation("smile")) {
                            this.unit.setAnimationAndIdleAfter("smile", "animation");
                        }

                        const rays = StandartAnimations.rays(this.unit, { skin: "yellow" });
                        rays.setLocalZOrder(0);
                        rays.replaceParentSamePlace(this.unit.parent, { keepScale: true });

                        this.unit.runAction(new cc.Sequence(
                            new cc.ScaleBy(0.382, 1.3),
                            new cc.ScaleBy(0.431, 1 / 1.3),
                            new cc.DelayTime(0.2),
                            new cc.CallFunc(this.onClose)
                        ));
                    } else if (this.help) {
                        this.help.enable();
                    }
                })
            ));
        }

        this.onUpdateTab();
    },

    createDesc: function () {
        const styles = cleverapps.styles.DonorProgressTab;

        const withOneDonor = this.config.donors.length === 1;

        const text = withOneDonor ? Messages.get("DonorProgressWindow.description", {
            code: cleverapps.unitsLibrary.getFamilyName(this.config.donors[0])
        }) : Messages.get("DonorProgressWindow.description.multidonors");

        const desc = this.desc = cleverapps.UI.generateOnlyText(text, cleverapps.styles.FONTS.WINDOW_TEXT);

        desc.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        desc.setDimensions(styles.width, withOneDonor ? styles.description.oneDonorHeight : styles.description.height);
        return desc;
    },

    createPreview: function () {
        const styles = cleverapps.styles.DonorProgressTab;
        const bg = cleverapps.UI.createScale9Sprite(bundles.donor_progress_window.frames.details_bg);
        bg.setContentSize2(styles.width, styles.preview.height);

        const bar = this.createBar();
        bg.addChild(bar);
        bar.setAlignment(styles.preview.bar);

        const landmarks = Map2dLocation.currentLocation && Map2dLocation.currentLocation.landmarks;
        if (landmarks) {
            const help = this.help = new cleverapps.UI.HelpButton({
                callback: function () {
                    cleverapps.focusManager.display({
                        focus: "DonorProgressHelp",
                        stack: true,
                        action: function (f) {
                            new GuideWindow(landmarks.getGuideWindowOptions(this.config));
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }.bind(this)
                    });
                }.bind(this)
            });
            bg.addChild(help);
            help.setAlignment(styles.preview.help);
        }

        const unit = this.unit = Achievements.getIcon(this.config);
        bg.addChild(unit);
        unit.setLocalZOrder(1);
        unit.setAlignment(styles.preview.icon);

        return bg;
    },

    createBar: function () {
        const styles = cleverapps.styles.DonorProgressTab.preview.bar;

        const progressBar = this.bar = new ScaledProgressBar({
            type: ScaledProgressBar.Types.green_large,
            barText: {
                text: "%from%%",
                font: cleverapps.styles.FONTS.DONOR_PROGRESS_FONT
            }
        });
        progressBar.setAnchorPoint(0.5, 0.5);
        progressBar.setScale(styles.scale);
        progressBar.setLength(styles.width / styles.scale);

        const barNode = new cc.Node();
        barNode.setAnchorPoint(0.5, 0.5);
        barNode.setContentSize(styles.width, progressBar.height);

        barNode.addChild(progressBar);
        progressBar.setPosition(barNode.width / 2, barNode.height / 2);

        if (this.config.donors.length === 1) {
            const unitImage = UnitView.getUnitImage(UnitsLibrary.LastStage(this.config.donors[0]), {
                alignAnchorX: true,
                alignAnchorY: true
            });
            cleverapps.UI.fitToBox(unitImage, styles.unit);

            unitImage.setPosition(barNode.width + styles.unit.dx, styles.unit.dy);
            barNode.addChild(unitImage);
        }

        return barNode;
    },

    createDonors: function () {
        const styles = cleverapps.styles.DonorProgressTab;

        const icons = this.config.donors.map((donorCode) => {
            const background = new cc.Scale9Sprite(bundles.customer_check_marks.frames.item_bg_png);
            background.setContentSize2(styles.donors.icon);

            const donorUnit = UnitsLibrary.LastStage(donorCode);
            const imageRes = Quest.GetUnitIconResource(Unit.GetKey(donorUnit));
            const image = imageRes ? new cc.Sprite(imageRes) : UnitView.getUnitImage(donorUnit, {
                preferStatic: true
            });
            image.setAlignment(background.width / 2, background.height / 2);
            cleverapps.UI.fitToBox(image, {
                width: background.width - styles.donors.icon.padding * 2,
                height: background.height - styles.donors.icon.padding * 2
            });
            background.addChild(image);

            if (cleverapps.unitsLibrary.isOpened(UnitsLibrary.LastStage(donorCode))) {
                const checkmark = new cc.Sprite(bundles.customer_check_marks.frames.customer_check_mark);
                checkmark.setAlignment(styles.donors.checkmark);
                background.addChild(checkmark);
            } else {
                const help = cleverapps.UI.createScale9Sprite(bundles.customer_check_marks.frames.lupa_mark);
                cleverapps.UI.applyHover(help);
                cleverapps.UI.onClick(help, () => {
                    this.onClose();
                    UnitLocator.find(Map2d.OPEN_UNIT, { code: donorCode }, { allowScrollWithFocus: true });
                });
                help.setAlignment(styles.donors.help);
                background.addChild(help);
            }
            return background;
        });

        const layout = new cleverapps.Layout(icons, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.donors.margin,
            padding: styles.donors.padding
        });

        const scroll = new cleverapps.UI.ScrollView(layout, {
            direction: cleverapps.UI.ScrollView.DIR_HORIZONTAL
        });
        scroll.setContentSize2(styles.width + styles.donors.padding.x * 2, layout.height);
        scroll.scrollToDefault();

        const title = cleverapps.UI.generateOnlyText(Messages.get("DonorProgressWindow.items"), cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);

        return new cleverapps.Layout([title, scroll], {
            direction: cleverapps.UI.VERTICAL,
            padding: {
                x: -styles.donors.padding.x
            }
        });
    },

    createTimer: function () {
        const timeLeft = cleverapps.achievements.getTimeLeft(this.config);
        return new Timer(timeLeft, this.onClose);
    },

    createFindButton: function () {
        const styles = cleverapps.styles.DonorProgressTab;

        return new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            text: Messages.get("Find"),
            onClicked: function () {
                this.onClose();
                UnitLocator.find(Map2d.BUILD, { code: this.config.donors[0] }, { allowScrollWithFocus: true });
            }.bind(this)
        });
    },

    getIcon: function () {
        return this.unit;
    }
});

cleverapps.styles.DonorProgressTab = {
    width: 840,
    margin: 20,

    description: {
        height: 120,
        oneDonorHeight: 220
    },

    preview: {
        height: 540,

        icon: {
            x: { align: "center" },
            y: { align: "center", dy: 55 }
        },

        bar: {
            x: { align: "center" },
            y: { align: "bottom", dy: 30 },
            width: 740,
            scale: 0.7,

            unit: {
                width: 145,
                height: 230,
                dx: -20,
                dy: 15
            }
        },

        help: {
            x: { align: "right", dx: 20 },
            y: { align: "top", dy: 20 }
        }
    },

    donors: {
        margin: 22,

        padding: {
            top: 20,
            bottom: 10,
            x: 100
        },

        icon: {
            width: 150,
            height: 150,
            padding: 14
        },

        checkmark: {
            x: { align: "right", dx: -8 },
            y: { align: "bottom", dy: 10 }
        },

        help: {
            x: { align: "right", dx: 5 },
            y: { align: "bottom", dy: -2 }
        }
    },

    button: {
        width: 250,
        height: 100
    }
};
